import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { bool } from '@ember/object/computed';
import config from 'sh-www/config/environment';

export const GET_TOKEN = 'token';
export const GET_EMAIL = 'email';

class ResetPasswordController extends Controller {
  queryParams = [GET_TOKEN, GET_EMAIL];

  token = null;
  email = null;

  @service('error-tracker') errorTracker;
  @service auth;
  @service router;
  @service api;

  @bool('token')
  showUpdatePassword;

  @action
  resetPassword(email) {
    const data = new URLSearchParams({ email });

    return this.api.post('password/email', { data });
  }

  @action
  async updatePassword(password, password_confirmation) {
    const { token, email } = this;

    await this.auth.resetPassword(token, email, password, password_confirmation);
    window.location.replace(config.DASHBOARD_URL);
    return new Promise(() => { });
  }

  @action
  toggle() {
    this.router.transitionTo('signin');
  }
}

export default ResetPasswordController;
